<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    class="status-icon"
    style="display: inline-block; width: 2rem; height: 2rem">
    <icon-colored-draft v-if="status === 'draft'" />
    <icon-colored-pending-approval v-if="status === 'pendingApproval'" />
    <icon-colored-approved v-if="status === 'approved' || status === 'ready'" />
    <icon-colored-rejected v-if="status === 'rejected'" />
    <icon-colored-cancelled v-if="status === 'retired'" />
    <icon-colored-partially-approved v-if="status === 'partiallyApproved'" />
    <icon-colored-partially-rejected v-if="status === 'partiallyRejected'" />
  </div>
</template>

<script type="text/babel">
  import {
    IconColoredApproved,
    IconColoredCancelled,
    IconColoredDraft,
    IconColoredPartiallyApproved,
    IconColoredPartiallyRejected,
    IconColoredPendingApproval,
    IconColoredRejected,
  } from '@/common/icons/colored';

  export default {
    components: {
      IconColoredDraft,
      IconColoredPendingApproval,
      IconColoredApproved,
      IconColoredRejected,
      IconColoredCancelled,
      IconColoredPartiallyApproved,
      IconColoredPartiallyRejected,
    },
    props: {
      status: {
        type: String,
        default: 'running',
      },
    },
  };
</script>
